import { useState } from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { PlenaLogo } from "@/components/brand/PlenaLogo";
import { AutosaveIndicator } from "@/components/common";
import { useEvaluation } from "./EvaluatorApp";

export function JobDrawer({ open, onOpenChange }) {
  const { ctx } = useEvaluation();
  const job = ctx.job;
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-full overflow-y-auto sm:max-w-xl" data-testid="job-drawer">
        <SheetHeader className="text-left">
          <p className="eyebrow">İlan Detayı</p>
          <SheetTitle className="font-heading text-2xl">{job.title}</SheetTitle>
          <p className="text-sm text-plena-text2">{[job.department, job.location].filter(Boolean).join(" · ")}</p>
        </SheetHeader>
        <article className="prose-job mt-8 pb-10">{job.description.split(/\n\n+/).map((p, i) => <p key={i}>{p}</p>)}</article>
      </SheetContent>
    </Sheet>
  );
}

export function JobButton({ className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" data-testid="view-job-button" onClick={() => setOpen(true)} className={`rounded-full ${className}`}><FileText className="mr-1.5 h-3.5 w-3.5" /> İlanı Gör</Button>
      <JobDrawer open={open} onOpenChange={setOpen} />
    </>
  );
}

export function EvaluatorHeader({ right }) {
  const { ctx, token, saveState } = useEvaluation();
  return (
    <header className="sticky top-0 z-30 border-b border-plena-border bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-14 max-w-6xl items-center gap-4 px-4 sm:px-6">
        <Link to={`/e/${token}`} data-testid="evaluator-home-link" className="flex items-center"><PlenaLogo height={20} /></Link>
        <div className="hidden h-5 w-px bg-plena-border sm:block" />
        <p className="hidden truncate text-sm font-medium sm:block">{ctx.job.title}</p>
        <div className="ml-auto flex items-center gap-3">
          <AutosaveIndicator state={saveState} />
          <span className="text-sm text-plena-text2" data-testid="header-progress">{ctx.progress.evaluated} / {ctx.progress.total}</span>
          {right}
        </div>
      </div>
    </header>
  );
}
